import Img1 from "../assets/images/research1.png";
import Img2 from "../assets/images/research2.png";
import Img3 from "../assets/images/research3.png";
import Img4 from "../assets/images/research4.png";
import Img5 from "../assets/images/research5.png";
import Img6 from "../assets/images/research6.png";
import Img7 from "../assets/images/research7.png";
import Img8 from "../assets/images/research8.png";
import Img9 from "../assets/images/research9.png";

export const research = [
  {
    researchTitle: "Astrophysics",

    img: Img1,

    id: 1,
  },
  {
    researchTitle: "Atomic, Mesoscopic and Optical Physics",

    img: Img2,

    id: 2,
  },
  {
    researchTitle: "Biological and Soft Systems",

    img: Img3,

    id: 3,
  },
  {
    researchTitle: "High Energy Physics",

    img: Img4,

    id: 4,
  },
  {
    researchTitle: "Microelectronics",

    img: Img5,

    id: 5,
  },
  {
    researchTitle: "Molecular Engineering",

    img: Img6,

    id: 6,
  },
  {
    researchTitle: "NanoPhotonics",

    img: Img7,

    id: 7,
  },
  {
    researchTitle: "Optoelectronics",

    img: Img8,

    id: 8,
  },
  {
    researchTitle: "Physics and Chemistry of Solids",

    img: Img9,

    id: 9,
  },
];
